import { render, staticRenderFns } from "./api-services-list.vue?vue&type=template&id=33001fb8&scoped=true&"
import script from "./api-services-list.vue?vue&type=script&lang=js&"
export * from "./api-services-list.vue?vue&type=script&lang=js&"
import style0 from "./api-services-list.vue?vue&type=style&index=0&id=33001fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33001fb8",
  null
  
)

export default component.exports